import React, { useContext } from 'react'
import { useMutation } from '@apollo/client'
import { Button } from 'semantic-ui-react'
import { NavLink, useLocation } from 'react-router-dom'
import TeamSelection from './TeamSelection'
import MenuItem from './MenuItem'
import DataContext from '../../contexts/DataContext'
import { AuthContext } from '@dexter-experts/auth-react'
import { LOGOUT } from '../../graphql/admin'

const AppHeader = () => {
    const location = useLocation()
    const { logout: authLogout } = useContext(AuthContext)
    const { user } = useContext(DataContext)

    const [logout] = useMutation(LOGOUT)

    const signOut = () => {
        logout({
            variables: { id: user.id },
        }).then(() => authLogout())
    }

    const path = location.pathname.substring(1).split('/')

    const hideHeader =
        path[0] === 'login' ||
        path[0] === 'signup' ||
        path[0] === 'first-time-signup-notice' ||
        (path[0] === 'admin' && path[1] === 'experts' && path[3] === 'review')

    if (hideHeader) return <div></div>

    return (
        <div className="site-navbar py-2">
            <div className="container">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="logo">
                        <div className="site-logo">
                            <NavLink to="/" className="js-logo-clone">
                                <img
                                    src={`${process.env.REACT_APP_AWS_S3_URL}/Dexterlogo.png`}
                                    alt="Logo"
                                />
                            </NavLink>
                        </div>
                    </div>
                    <div className="main-nav d-none d-lg-block">
                        <nav
                            className="site-navigation text-right text-md-center"
                            role="navigation"
                        >
                            <ul className="site-menu js-clone-nav d-none d-lg-block">
                                <MenuItem path="/projects" name="Projects" />
                                <MenuItem path="/experts" name="Experts" />
                                <MenuItem path="/payments" name="Payments" />
                                {user.isSuperUser() && (
                                    <MenuItem path="/admin" name="Admin" />
                                )}
                                {user.isSuperUser() && <TeamSelection />}
                                <li>
                                    <NavLink to="#">
                                        <Button
                                            basic
                                            color="red"
                                            size="small"
                                            onClick={signOut}
                                        >
                                            Sign out
                                        </Button>
                                    </NavLink>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="icons">
                        <a
                            href="# "
                            className="site-menu-toggle js-menu-toggle ml-3 d-inline-block d-lg-none"
                        >
                            <span className="icon-menu"></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppHeader
